<template>
    <div id="wiaa-frame" ref="wiaa-frame">
        <div class="container is-max-desktop auth-card columns">

            <div class="column left-side">

                <div class="columns">
                    <div class="column pt-4">
                        <h1>
                            <strong>my</strong>247ed.com
                        </h1>
                    </div>
                    <div class="column has-text-centered">
                        <img alt="maximize" src="@/assets/partner_assets/wiaa.png"/>
                    </div>
                    <div class="column has-text-right pt-5">
                        <img src="@/assets/partner_assets/finalforms.jpg" />
                    </div>
                </div>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-handshake-simple"></i></div>
                        <div class="column">
                            <p class="mb-5"><strong><a href="https://app.my247ed.com">my247ed.com</a></strong> has partnered with <strong><a href="https://www.wiaa.com" target="_blank">Washington Interscholastic Activities Association (WIAA)</a></strong> and <strong><a href="https://www.finalforms.com" target="_blank">FinalForms</a></strong> to provide coach management and compliance solutions.  Below is a walk-through of the basic process of getting signed up, taking a online clinic course, and making sure that certification has been properly awarded and tracked.</p>
                            <p><strong>For additional information please visit: </strong><a href="https://mywiaa.wiaa.com/finalforms/" target="_blank">https://mywiaa.wiaa.com/finalforms/</a></p>

                            <div class="mt-6 mb-5">
                                <b-button tag="router-link" type="is-primary" to="/" outlined icon-left="arrow-left">Return to Login</b-button>
                            </div>

                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-envelope-open-text"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Starting from FinalForms</h6>

                            <p class="mb-5">You may have received a invite to FinalForms that a training and certification is now available to you.  Once you are logged into FinalForms you will see a list of available Certifications.  Simply click on the <strong>"Take on my247ed"</strong> button to be directed to our site and attempt to point you in the right direction.</p>
                            <p>
                                <img src="@/assets/partner_assets/walkthrough/finalforms.png" class="bordered" />
                            </p>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-arrow-right-to-bracket"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Login or Signup</h6>

                            <p class="mb-5">If you have taken one of our Professional Development courses or received Clock Hours for a WIAA or other offering you may already have an account with us.  Based on information passed from FinalForms we may either prompt for a login or suggest you sign-up.  If you feel you already have an account but we still direct you to signup it may be under a different e-mail address.</p>

                            <div class="columns mt-5 mb-5">
                                <div class="column">
                                    <div>
                                        <b-button expanded tag="router-link" type="is-primary" to="/" icon-left="arrow-right-to-bracket">Login</b-button>
                                    </div>
                                    <div class="mt-4">
                                        <b-button expanded outlined tag="router-link" type="is-primary" size="is-small" to="/assistance" icon-left="question-circle">Login Assistance</b-button>
                                    </div>
                                </div>
                                <div class="column has-text-centered pt-4">
                                    <strong>OR</strong>
                                </div>
                                <div class="column has-text-right">
                                    <b-button expanded tag="router-link" type="is-primary" to="/signup" icon-left="user-plus">Sign Up</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-browsers"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Enroll in the Clinic Course</h6>

                            <p class="mb-5">Once logged into <strong><span style="color: #336699;">my</span>247ed.com</strong>, make your way to the <strong>Online Course Catalog</strong> and find the Clinic you are looking for.  Click the <strong>"Enroll"</strong> button to enroll in the course.  This will add it to your <strong>Course Enrollments</strong> where you can start the course at any time.</p>
                            <p>
                                <img src="@/assets/partner_assets/walkthrough/enroll_course.png" class="bordered" />
                            </p>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-chalkboard-teacher"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Take the Clinic Course</h6>

                            <p class="mb-5">Taking the course is straight forward.  The course's outline is on the left side.  You won't be able to skip ahead until previous lessons are complete.  Some lessons require you to watch a video and spend a required amount of time before you can click the <strong>"Complete Lesson"</strong> button to move on to the next lesson.</p>
                            <p>
                                <img src="@/assets/partner_assets/walkthrough/take_course.png" class="bordered" />
                            </p>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-check"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Complete the Clinic Course</h6>

                            <p class="mb-5">When you have finished all the course's content and taken all quizzes you may complete the course. Click the button <strong>"Click to Complete Course"</strong>.</p>
                            <p>
                                <img src="@/assets/partner_assets/walkthrough/complete_course.png" class="bordered" />
                            </p>
                        </div>
                    </div>
                </section>

                <hr/>
                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-file-certificate"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Complete the Certification Application</h6>

                            <p class="mb-5">After you complete the course you can apply for the specific WIAA certification for that clinic.  <strong>The completion of the application is required to award the certification and sync with FinalForms.</strong></p>
                            <p>
                                <img src="@/assets/partner_assets/walkthrough/application.png" class="bordered" />
                            </p>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-sync"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Sync with FinalForms</h6>

                            <p class="mb-5">You can then return to <strong>FinalForms</strong> and sync your progress to officially complete the certification tracking.  In the Certifications section click on <strong>"<i class="far fa-sync mr-1"></i>Sync Certifications: <span style="color: #336699;">my</span>247ed.com"</strong>.  All certifications that are complete will show a green status.</p>
                            <p>
                                <img src="@/assets/partner_assets/walkthrough/complete.png" class="bordered" />
                            </p>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-list-check"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">If you are having problems syncing your certifications, verify your WIAA Membership ID.</h6>

                            <p class="mb-5">Your "WIAA Membership ID" is typically automatically filled for you when you follow a link from FinalForms.  If for some reason this integration is not properly setup you can correct this from <strong>Your Account</strong> > <strong>Certifications & Organizations</strong>.  Under <strong>"Washington Interscholastic Activities Association (WIAA)"</strong> fill in your <strong>"WIAA Membership ID"</strong> and click <strong>"Save Changes"</strong>.  A <a href="https://wiaa.finalforms.com/lookup_membership_id" target="_blank">Lookup Tool</a> is provided to retrieve your ID.  Return to <strong>FinalForms</strong> to sync as described in the previous step.</p>
                            <p>
                                <img src="@/assets/partner_assets/walkthrough/cert.png" class="bordered" />
                            </p>
                        </div>
                    </div>
                </section>

                <hr/>

                <section class="content mt-3">
                    <div class="columns">
                        <div class="column is-narrow"><i class="fal fa-fw fa-2x fa-messages-question"></i></div>
                        <div class="column">
                            <h6 class="mt-2 mb-4">Need further assistance?</h6>

                            <p class="mb-5">If you are still having problems with this process feel free to reach out to us and we'll get you sorted out!</p>
                        </div>
                    </div>

                    <div class="columns mb-5">
                        <div class="column pl-6 ml-5">
                            <b-button tag="router-link" type="is-primary" to="/" size="is-small" outlined icon-left="arrow-left">Return to Login</b-button>
                        </div>
                        <div class="column is-3 has-text-right">
                            <a href="mailto:support@my247ed.com?subject=WIAA%20Assistance">
                                <b-button type="is-primary" expanded icon-left="messages-question">Get Help</b-button>
                            </a>
                        </div>
                    </div>

                </section>


            </div>
        </div>
    </div>
</template>

<script>
    import {client as http} from "../../http_client";
    import {mapActions, mapGetters} from "vuex";

    export default {
        components: {},
        data: function() {
            return {
                processing: false,
                resetEmail: '',
            };
        },
        methods: {
            ...mapActions(['login']),
            resetPassword() {
                if (!this.processing) {
                    this.processing = true;
                    http.post('app/users/reset', {email: this.resetEmail}, {force: true}).then(response => {
                        this.$router.push('/');
                        this.$notify('success', 'Password Reset', 'Please check your email for password reset instructions.', {duration: 10000, permanent: true});
                    }).catch(err => {
                        if (err) console.log(err.response);
                        if (err.response.status === 404) {
                            window.alert('No valid account was found.  Check your e-mail address for errors or sign-up.');
                        } else {
                            window.alert('An error occurred. If you need additional help please contact us at support@my247ed.com.');
                        }
                        this.processing = false;
                    });
                }
            },
        },
        mounted() {

        }
    };
</script>

<style lang="scss">
    #wiaa-frame {
        display: flex;
        min-height: 100vh;
        align-items: center;
        justify-content: center;
        background: #224C74 radial-gradient(#336699, #1e385c);

        .auth-card {
            margin: 4rem 2rem 8rem;
            border-radius: 8px;
            box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);

            .left-side {
                background-color: #FFFFFF;
                padding: 4rem 3.5rem 4rem 3.5rem;
                border-radius: 5px;
                color: #666666;

                strong {
                    color: #484848;
                }

                h1 {
                    font-weight: normal;
                    font-size: 2.6rem !important;
                    color: #282828;
                    margin-bottom: 1.5rem;
                    letter-spacing: -1px;

                    strong {
                        color: #336699;
                        font-weight: 900;
                    }

                    @media (max-width: 768px) {
                        font-size: 2.2rem !important;
                        margin-bottom: 1rem;
                    }
                }

                > p {
                    font-size: 1.2rem;
                    line-height: 1.7rem;
                }

                .is-size-7 {
                    font-size: 0.85rem !important;
                }

                .signup {
                    border-top: 1px solid #e9e9e9;
                    padding-top: 1.5rem;
                    margin-top: 4rem;

                    .button {
                        padding-left: 1.3rem;
                    }

                    @media (max-width: 768px) {
                        margin-top: 2rem;
                    }
                }

                @media (max-width: 768px) {
                    border-radius: 5px;
                    padding: 3rem 1rem 2.5rem 1rem;
                    box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.3);
                }
            }


            h4 {
                font-size: 1.2rem;
                margin-top: 1.5rem;
                margin-bottom: 2rem;
                padding-bottom: 0.8rem;

                i {
                    color: #336699;
                }

                border-bottom: 1px dashed #ddd;
            }

            @media (max-width: 768px) {
                margin: 1rem;
                box-shadow: none;
            }
        }


        @media (max-width: 768px) {
            align-items: normal;
            justify-content: normal;
        }

        span {
            &.beta {
                color: #333;
                border: 1px solid #c2c2c2;
                border-radius: 3px;
                padding: 0 4px;
                font-size: 0.6rem;
                margin-left: 0.5rem;
                vertical-align: super;
                font-weight: normal;
                letter-spacing: normal;
            }
        }
    }

    .required-flag {
        color: red;
    }

    .bordered {
        border: 1px solid #b6b6b6;
    }
</style>
